import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { CandidateTokenStorageService } from '../storage/candidate-token-storage.service';
import { CandidateTenantContextService } from '../tenant/candidate-tenant-context.service';

export const candidateAuthGuard: CanActivateFn = () => {
  const tokens = inject(CandidateTokenStorageService);
  const tenantContext = inject(CandidateTenantContextService);
  const router = inject(Router);

  if (tokens.getAccessToken()) {
    return true;
  }

  return router.createUrlTree(['/login'], { queryParams: tenantContext.getTenantQueryParams() });
};
